import { Box, Flex, Skeleton, SkeletonCircle, StackDivider, VStack } from "@chakra-ui/react";

export const SearchResultCardSkeleton = () => {
    const fakeKeyFigures: { key: number; labelWidth: number; valueWidth: number }[] = [
        { key: 1, labelWidth: 170, valueWidth: 48 },
        { key: 2, labelWidth: 124, valueWidth: 98 },
        { key: 3, labelWidth: 114, valueWidth: 84 },
        { key: 4, labelWidth: 128, valueWidth: 82 },
        { key: 5, labelWidth: 144, valueWidth: 101 },
    ];

    return (
        <Flex direction="column" boxShadow="base" rounded="8px" p={[2, 3]}>
            <Flex mb={4} flexGrow={1} overflow="hidden">
                <SkeletonCircle flexShrink={0} size="6" mr={1} />
                <Flex direction="column">
                    <Skeleton w="178px" h={2} mt={0.5} mb={1} />
                    <Skeleton w="100px" h={2} />
                </Flex>
            </Flex>
            <Box h={["121px", "127px", "117px", "140px"]} mb={2} />
            <VStack w="100%" divider={<StackDivider borderColor="gray.100" />} spacing={0} mb={2}>
                {fakeKeyFigures.map(({ key, labelWidth, valueWidth }) => (
                    <Flex key={key} justify="space-between" align="center" w="100%" h={6}>
                        <Skeleton w={`${labelWidth}px`} h={2} />
                        <Skeleton w={`${valueWidth}px`} h={2} />
                    </Flex>
                ))}
            </VStack>
            <Flex>
                <Skeleton h={5} flex={1} borderRadius="8px" />
                <Skeleton w={5} h={5} borderRadius="8px" ml={2} />
            </Flex>
        </Flex>
    );
};
